import "../style/Activities.css";

/**
 * Payment-instructions modal shown when a visitor reserves a class spot.
 * Used by the Activities timeline and by story pages.
 */
const ReserveModal = ({ title, onClose }) => (
  <div className="activities-modal-overlay" onClick={onClose}>
    <div className="activities-modal" onClick={(e) => e.stopPropagation()}>
      <div className="activities-modal-header">
        <h2 className="activities-modal-title">RESERVE YOUR SPOT</h2>
        <button className="activities-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      </div>

      <p className="activities-modal-class-name">{title}</p>

      <div className="activities-modal-section">
        <p className="activities-label">Payment Instructions</p>
        <ol className="activities-payment-list">
          <li>Send payment via Venmo, Zelle, or Cash App</li>
          <li>Include your full name and class date in the note</li>
          <li>Please Show your payment confirmation at the entrance</li>
        </ol>
      </div>

      <div className="activities-modal-section activities-modal-divider">
        <p className="activities-label">Payment Details</p>
        <div className="activities-payment-details">
          <p><span>Venmo:</span> @dancer_boysmith</p>
          <p><span>Zelle:</span> smithjoshua96@gmail.com</p>
          <p><span>Cash:</span> Bring it with you!</p>
        </div>
      </div>

      <p className="activities-modal-note">
        Spots are confirmed on a first-come, first-served basis once payment is received.
      </p>
    </div>
  </div>
);

export default ReserveModal;
